export default __webpack_public_path__ + "static/media/attributeDefault.368a240b.png";